import { Component, OnInit } from '@angular/core';
import { TipoDocumento} from '../model/tipo-documento.model';
import { CrudService } from 'app/shared/services/crud.service';
import { DataTableBasicComponent } from 'app/shared/components/data-table/data-table-basic.component';
import { Empresa } from 'app/cadastro/model/empresa.model';
import { FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs/Subscription';
import { Toolbar } from 'app/shared/model/toolbar.model';
import { ToolbarService } from 'app/shared/services/toolbar.service';
import { SessionService } from 'app/shared/services/session.service';
import { DblinkedSessionService } from 'app/shared/services/dblinked-session.service';
import { HttpService } from 'app/shared/services/http.service';
import { ConfigService } from 'app/shared/services/config.service';

@Component({
  selector: 'app-tipo-documento',
  templateUrl: './tipo-documento.component.html',
  styleUrls: ['./tipo-documento.component.scss'],
  providers: [CrudService]
})
export class TipoDocumentoComponent extends DataTableBasicComponent implements OnInit {
  public tipoDocumento: TipoDocumento = new TipoDocumento();
  public registrosTipoDocumento: Array<TipoDocumento> = new Array();
  formulario: FormGroup;

  private sessionSubscription: Subscription;

  ctrlSave: boolean;
  entityFilter: string = null;
  editarConta: boolean;
  novaConta: boolean;
  ids: Array<any> = new Array();
  select: Array<any> = new Array();

  title = 'Tipo Documento';
  subtitle = "Tipo Documento";
  cod: any;
  descricao: string;

  selectedTipoArquivo: any;
  tipoArquivo = new Array();

  public toolbarMain = new Toolbar();

  toolbarMainIni = [
    { key: "voltar", icon: 'navigate_before', text: 'Voltar', tooltip: 'Voltar', visible: false, disabled: false, color: 'default', onClick: () => this.carregar() },
    { key: "edit", icon: 'edit', text: 'Editar', tooltip: 'Editar', visible: false, disabled: false, color: 'default', onClick: () => this.loadEditarRegistro() },
    { key: "delete", icon: 'delete', text: 'Remover', tooltip: 'Remover', visible: false, disabled: false, color: 'red', onClick: () => this.excluirRegistro() },
    { key: "add", icon: 'add', text: 'Novo', tooltip: 'Novo', visible: true, disabled: false, color: 'green', onClick: () => this.criarNovo() },
    { key: "saveNew", icon: 'save', text: 'Salvar', tooltip: 'Salvar Novo Registro', visible: false, disabled: false, color: 'green', onClick: () => this.salvarNovoRegistro() },
    { key: "save", icon: 'save', text: 'Salvar', tooltip: 'Salvar Alteração de Registro', visible: false, disabled: false, color: 'green', onClick: () => this.salvarAlteracaoRegistro() },
  ]

  constructor(crudService: CrudService,
      private toolbarService: ToolbarService,
      private sessionService: SessionService,
      private dblinkedSessionService: DblinkedSessionService,
      private httpService: HttpService,
      private configService: ConfigService,
      private messageService: MessageService,
      ) {
    super(crudService);
  }

  ngOnInit() {
    this.toolbarService.hidden = true;
    this.createForm(new TipoDocumento());
    this.novaConta = false;
    this.editarConta = false;

    this.sessionSubscription = this.sessionService.initSubscribe(
      this.dblinkedSessionService.sessionChanged,
      () => this.carregar()
      );
  }

  createForm(tipoDocumento: TipoDocumento){
    this.formulario = new FormGroup({
      cod: new FormControl(tipoDocumento.cod),
      descricao: new FormControl(tipoDocumento.descricao),
      tipoArquivo: new FormControl(tipoDocumento.tipoArquivo),
    })
  }

  criarNovo() {
    this.novaConta = true;
    this.editarConta = false;
    this.title = 'Cadastrar';

    this.loadTipoArquivo();
    this.limpaCamposForm();

    this.toolbarMain.setVisible('saveNew', this.novaConta);
    this.toolbarMain.setVisible('voltar', this.novaConta);
    this.toolbarMain.setVisible('add', false);
  }

  carregar() {
    this.toolbarMain.setAll(this.toolbarMainIni);

    this.title = 'Tipo Documento';
    this.subtitle = 'Tipo Documento';
    this.novaConta = false;
    this.editarConta = false;
    this.ids = new Array();
    this.select = new Array();

    this.limpaCamposForm();

    this.loadRegistros();
    
  }

  loadTipoArquivo(){
    this.httpService.wait();
    this.httpService
      .get(`/tipoarquivo?$select=id,nome&$orderby=nome`)
      .subscribe(
        (retorno) => {
          this.tipoArquivo = new Array();
          this.tipoArquivo.push({
            id: 0,
            nome: 'Nenhum(a)'
          });
          retorno.value.forEach(item => {
            this.tipoArquivo.push(item);
          })
        },
        error => this.httpService.handleError(error, () => this.carregar()),
        () => this.httpService.done()
      );
  }

  loadRegistros() {
    this.httpService.wait();
    this.httpService
      .get(`/tipodocumento?$select=cod,descricao,tipoArquivo/nome&$count=true&$orderby=cod`)
      .subscribe(
        (retorno) => {
          this.registrosTipoDocumento = new Array();
          retorno.value.forEach(item => {
            this.registrosTipoDocumento.push(item);
          })
        },
        error => this.httpService.handleError(error, () => this.carregar()),
        () => this.httpService.done()
      );
  }

  loadEditarRegistro() {
    this.title = 'Editar';
    this.novaConta = false;
    this.editarConta = true;

    this.toolbarMain.setVisible('delete', this.editarConta);
    this.toolbarMain.setVisible('save', this.editarConta);
    this.toolbarMain.setVisible('voltar', this.editarConta);
    this.toolbarMain.setVisible('add', false);
    this.toolbarMain.setVisible('edit',  false);
    
    this.limpaCamposForm();
    this.loadTipoArquivo();

    this.httpService.wait();
    this.httpService.get(`/tipodocumento(${this.ids[0]})?$select=cod,descricao,tipoArquivo/id,tipoArquivo/nome&$count=true`)
      .subscribe(item => {
        this.cod = item.value.cod;
        this.descricao = item.value.descricao;
        this.selectedTipoArquivo = item.value.tipoArquivo?.id;
      },
      error => this.httpService.handleError(error, () => this.carregar()),
      () => this.httpService.done());
  }

  salvarNovoRegistro() {
    if (this.validacao()) {
      return;
    }

    const jsonEnvio = {
      cod: this.cod,
      descricao: this.descricao,
      tipoArquivo: {
        id: this.selectedTipoArquivo
      }
    }

    this.httpService.wait();
    this.httpService.post('/tipodocumento', jsonEnvio)
      .subscribe(result => {

        if (!(result === null || result === undefined)) {
          this.messageService.add({
            severity: 'success', key: 'messageLinnks', summary: 'Sucesso  ', detail: 'Registro cadastrado com sucesso!'
          });
          this.carregar();
        } else {
          this.messageService.add({
            severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'Falha no cadastro. Tente novamente'
          });
          this.carregar();
          return;
        }
      }, error => this.httpService.handleError(error, () => this.salvarNovoRegistro()),
        () => this.httpService.done());
  }

  salvarAlteracaoRegistro() {
    if (this.validacao()) {
      return;
    }

    let key = this.ids[0];

    const jsonEnvio = {
      cod: this.cod,
      descricao: this.descricao,
      tipoArquivo: {
        id: this.selectedTipoArquivo
      }
    }

    this.httpService.wait();
    this.httpService.patch('/tipodocumento', key, jsonEnvio, null)
      .subscribe(result => {
        if (result === null) {
          this.messageService.add({
            severity: 'success', key: 'messageLinnks', summary: 'Sucesso  ', detail: 'Registro alterado com sucesso!'
          });
          this.carregar();
        } else {
          this.messageService.add({
            severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'Falha na alteração do registro!'
          });
          this.carregar();
          return;
        }
      },
        error => this.httpService.handleError(error, () => this.salvarAlteracaoRegistro()),
        () => this.httpService.done());
  }

  excluirRegistro() {
    if (confirm('Deseja deletar o registro selecionado? ')) {
      this.httpService.wait();
      this.httpService.delete('/tipodocumento', this.ids)
        .subscribe(result => {
          if (result === null) {
            this.messageService.add({
              severity: 'success', key: 'messageLinnks',
              summary: '',
              detail: 'Registro excluído com sucesso!'
            });
            this.carregar();
            this.ids = [];
          } else {
            this.messageService.add({
              severity: 'warn', key: 'messageLinnks',
              summary: '',
              detail: 'Falha na exclusão. Tente novamente!'
            });
          }
        },
        error => this.httpService.handleError(error, () => this.carregar()),
        () => this.httpService.done());
    }
  }

  onRowSelect(event: any) {
    this.ids = new Array();
    this.ids.push(event.data.id);

    const choosen = this.select[this.select.length - 1];
    this.select.length = 0;
    this.select.push(choosen);
    this.change()
  }

  onRowUnselect(event: any) {
    this.select = new Array();
    this.ids = new Array();
    this.change();
  }

  change(){
    const selectionSize = this.select.length;
    this.toolbarMain.setVisible('edit', selectionSize >=1); 
    this.toolbarMain.setVisible('delete', selectionSize >=1); 
  }

  validacao(): boolean {
    if (this.cod === undefined || this.cod === null || this.cod == '') {
      this.messageService.add({ severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'Cod inválido' });
      return true;
    }

    if (this.descricao === undefined || this.descricao === null || this.descricao == '') {
      this.messageService.add({ severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'Descrição inválida' });
      return true;
    }

    if (this.selectedTipoArquivo === undefined || this.selectedTipoArquivo === null) {
      this.messageService.add({ severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'Tipo Arquivo inválido' });
      return true;
    }

    return false;
  }

  private limpaCamposForm() {
    this.cod = null;
    this.descricao = null;
    this.selectedTipoArquivo = null;
  }

  get hasEmpresaSelected(): boolean {
    return this.dblinkedSessionService.hasEmpresaSelected;
  }

  get loading(): boolean {
    return this.httpService.loading;
  }

  get rowsPerPage() {
    return this.configService.applicationConfig.rowsPerPage;
  }
  get rows() {
    return this.configService.applicationConfig.rows;
  }
  get pageLinks() {
    return this.configService.applicationConfig.pageLinks;
  }

  get empresa(): Empresa {
    return this.dblinkedSessionService.empresa && this.dblinkedSessionService.empresa.id ? this.dblinkedSessionService.empresa : null;
  }
}
